import React, { useEffect, useState } from "react";
import "./Anoutment.css";
import calendar from "../../assets/calendar.png";
import { Link } from "react-router-dom";
import { dataNews } from "../../data-news";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
function Annoument() {
  const [isMobile, setIsMobile] = useState(window.screen.width <= 768);
  // ข้อมูลข่าวสาร
  const announcementData = dataNews
  const { t } = useTranslation();
  useEffect(() => {
    // ฟังก์ชันตรวจสอบขนาดหน้าจอ
    const handleResize = () => {
      if (window.screen.width <= 768) {
        setIsMobile(true); // ถ้าเป็นมือถือหรือขนาดเล็ก
      } else {
        setIsMobile(false); // ถ้าเป็นขนาดใหญ่
      }
    };

    // เรียกใช้เมื่อแสดงผลครั้งแรกและเวลาเปลี่ยนขนาดหน้าจอ
    handleResize();
    window.addEventListener("resize", handleResize);

    // ลบ event listener เมื่อ component ถูก unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const navigate = useNavigate();
  const handleCardClick = (id) => {
    navigate(`/detailNews/${id}`);
  };

  return (
    <div className="annoument-content">
      <div className="text-annoument">
        <div className="text-header-annoument">News and Activity</div>
        <Link to="/news&events" style={{textDecoration: 'none'}}>
          <div className="button-lean-more">
            <span>{t('view_all')}</span>
          </div>
        </Link>
      </div>
      {!isMobile && (
        <div className="content-new-activity">
          <div className="main1-card-annoument" onClick={() => handleCardClick(announcementData[announcementData.length - 1].id)}>
            <img
              src={announcementData[announcementData.length - 1].image}
              alt=""
              className="main-image"
            />
            <div className="content-text-annoument">
              <div className="box-head-annoutment">
                <div
                  className={
                    announcementData[announcementData.length - 1].type ===
                    "Activity"
                      ? "box-activety"
                      : announcementData[announcementData.length - 1].type ===
                        "News"
                      ? "box-new"
                      : "box-blog"
                  }
                >
                  {announcementData[announcementData.length - 1].type.toUpperCase()}
                </div>
                <div className="date">
                  <img src={calendar} alt="" className="calendar" />
                  <div className="text-date">
                    {announcementData[announcementData.length - 1].date}
                  </div>
                </div>
              </div>
              <div className="box-text-annoutment">
                <div className="box-text-head-annoutment-no-camp">
                  {announcementData[announcementData.length - 1].name}
                </div>
                <div className="box-text-sub-annoutmen-no-camp">
                  {announcementData[announcementData.length - 1].description}
                </div>
              </div>
            </div>
          </div>
          <div className="box-sub-card-content" >
            <div className="sub-card-annoument">
              <div className="sub-carf-content" onClick={() => handleCardClick(announcementData[announcementData.length - 2].id)}>
                <img
                  src={announcementData[announcementData.length - 2].image}
                  alt=""
                  className="image-sub-card"
                />
                <div className="text-sub-carf-content">
                  <div className="box-head-annoutment">
                    <div
                      className={
                        announcementData[announcementData.length - 2].type ===
                        "Activity"
                          ? "box-activety"
                          : announcementData[announcementData.length - 2]
                              .type === "News"
                          ? "box-new"
                          : "box-blog"
                      }
                    >
                      {announcementData[announcementData.length - 2].type.toUpperCase()}
                    </div>
                    <div className="date">
                      <img src={calendar} alt="" className="calendar" />
                      <div className="text-date">
                        {announcementData[announcementData.length - 2].date}
                      </div>
                    </div>
                  </div>
                  <div className="box-text-annoutment">
                    <div className="box-text-head-annoutment">
                      {announcementData[announcementData.length - 2].name}
                    </div>
                    <div className="box-text-sub-annoutment">
                      {
                        announcementData[announcementData.length - 2]
                          .description
                      }
                    </div>
                  </div>
                </div>
              </div>
              <div className="sub-carf-content" onClick={() => handleCardClick(announcementData[announcementData.length - 3].id)}>
                <img
                  src={announcementData[announcementData.length - 3].image}
                  alt=""
                  className="image-sub-card"
                />
                <div className="text-sub-carf-content">
                  <div className="box-head-annoutment">
                    <div
                      className={
                        announcementData[announcementData.length - 3].type ===
                        "Activity"
                          ? "box-activety"
                          : announcementData[announcementData.length - 3]
                              .type === "News"
                          ? "box-new"
                          : "box-blog"
                      }
                    >
                      {announcementData[announcementData.length - 3].type.toUpperCase()}
                    </div>
                    <div className="date">
                      <img src={calendar} alt="" className="calendar" />
                      <div className="text-date">
                        {announcementData[announcementData.length - 3].date}
                      </div>
                    </div>
                  </div>
                  <div className="box-text-annoutment">
                    <div className="box-text-head-annoutment">
                      {announcementData[announcementData.length - 3].name}
                    </div>
                    <div className="box-text-sub-annoutment">
                      {
                        announcementData[announcementData.length - 3]
                          .description
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="sub-card-annoument">
              <div className="sub-carf-content" onClick={() => handleCardClick(announcementData[announcementData.length - 4].id)}>
                <img
                  src={announcementData[announcementData.length - 4].image}
                  alt=""
                  className="image-sub-card"
                />
                <div className="text-sub-carf-content">
                  <div className="box-head-annoutment">
                    <div
                      className={
                        announcementData[announcementData.length - 4].type ===
                        "Activity"
                          ? "box-activety"
                          : announcementData[announcementData.length - 4]
                              .type === "News"
                          ? "box-new"
                          : "box-blog"
                      }
                    >
                      {announcementData[announcementData.length - 4].type.toUpperCase()}
                    </div>
                    <div className="date">
                      <img src={calendar} alt="" className="calendar" />
                      <div className="text-date">
                        {announcementData[announcementData.length - 4].date}
                      </div>
                    </div>
                  </div>
                  <div className="box-text-annoutment">
                    <div className="box-text-head-annoutment">
                      {announcementData[announcementData.length - 4].name}
                    </div>
                    <div className="box-text-sub-annoutment">
                      {
                        announcementData[announcementData.length - 4]
                          .description
                      }
                    </div>
                  </div>
                </div>
              </div>
              <div className="sub-carf-content" onClick={() => handleCardClick(announcementData[announcementData.length - 5].id)}>
                <img
                  src={announcementData[announcementData.length - 5].image}
                  alt=""
                  className="image-sub-card"
                />
                <div className="text-sub-carf-content">
                  <div className="box-head-annoutment">
                    <div
                      className={
                        announcementData[announcementData.length - 5].type ===
                        "Activity"
                          ? "box-activety"
                          : announcementData[announcementData.length - 5]
                              .type === "News"
                          ? "box-new"
                          : "box-blog"
                      }
                    >
                      {announcementData[announcementData.length - 5].type.toUpperCase()}
                    </div>
                    <div className="date">
                      <img src={calendar} alt="" className="calendar" />
                      <div className="text-date">
                        {announcementData[announcementData.length - 5].date}
                      </div>
                    </div>
                  </div>
                  <div className="box-text-annoutment">
                    <div className="box-text-head-annoutment">
                      {announcementData[announcementData.length - 5].name}
                    </div>
                    <div className="box-text-sub-annoutment">
                      {
                        announcementData[announcementData.length - 5]
                          .description
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="sub-card-annoument">
              <div className="sub-carf-content" onClick={() => handleCardClick(announcementData[announcementData.length - 6].id)}>
                <img
                  src={announcementData[announcementData.length - 6].image}
                  alt=""
                  className="image-sub-card"
                />
                <div className="text-sub-carf-content">
                  <div className="box-head-annoutment">
                    <div
                      className={
                        announcementData[announcementData.length - 6].type ===
                        "Activity"
                          ? "box-activety"
                          : announcementData[announcementData.length - 6]
                              .type === "News"
                          ? "box-new"
                          : "box-blog"
                      }
                    >
                      {announcementData[announcementData.length - 6].type.toUpperCase()}
                    </div>
                    <div className="date">
                      <img src={calendar} alt="" className="calendar" />
                      <div className="text-date">
                        {announcementData[announcementData.length - 6].date}
                      </div>
                    </div>
                  </div>
                  <div className="box-text-annoutment">
                    <div className="box-text-head-annoutment">
                      {announcementData[announcementData.length - 6].name}
                    </div>
                    <div className="box-text-sub-annoutment">
                      {
                        announcementData[announcementData.length - 6]
                          .description
                      }
                    </div>
                  </div>
                </div>
              </div>
              <div className="sub-carf-content" onClick={() => handleCardClick(announcementData[announcementData.length - 7].id)}>
                <img
                  src={announcementData[announcementData.length - 7].image}
                  alt=""
                  className="image-sub-card"
                />
                <div className="text-sub-carf-content">
                  <div className="box-head-annoutment">
                    <div
                      className={
                        announcementData[announcementData.length - 7].type ===
                        "Activity"
                          ? "box-activety"
                          : announcementData[announcementData.length - 7]
                              .type === "News"
                          ? "box-new"
                          : "box-blog"
                      }
                    >
                      {announcementData[announcementData.length - 7].type.toUpperCase()}
                    </div>
                    <div className="date">
                      <img src={calendar} alt="" className="calendar" />
                      <div className="text-date">
                        {announcementData[announcementData.length - 7].date}
                      </div>
                    </div>
                  </div>
                  <div className="box-text-annoutment">
                    <div className="box-text-head-annoutment">
                      {announcementData[announcementData.length - 7].name}
                    </div>
                    <div className="box-text-sub-annoutment">
                      {
                        announcementData[announcementData.length - 7]
                          .description
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
        </div>
      )}
      {isMobile && (
        <div className="mobile-annoument">
          <div className="mobile-card-annoument" onClick={() => handleCardClick(announcementData[announcementData.length - 1].id)}>
            <img
              src={announcementData[announcementData.length - 1].image}
              alt=""
              className="main-image"
            />
            <div className="content-text-annoument">
              <div className="box-head-annoutment">
                <div
                  className={
                    announcementData[announcementData.length - 1].type ===
                    "Activity"
                      ? "box-activety"
                      : announcementData[announcementData.length - 1].type ===
                        "News"
                      ? "box-new"
                      : "box-blog"
                  }
                >
                  {announcementData[announcementData.length - 1].type.toUpperCase()}
                </div>
                <div className="date">
                  <img src={calendar} alt="" className="calendar" />
                  <div className="text-date">
                    {announcementData[announcementData.length - 1].date}
                  </div>
                </div>
              </div>
              <div className="box-text-annoutment">
                <div className="box-text-head-annoutment">
                  {announcementData[announcementData.length - 1].name}
                </div>
                <div className="box-text-sub-annoutment">
                  {announcementData[announcementData.length - 1].description}
                </div>
              </div>
            </div>
          </div>
          <div className="mobile-card-annoument" onClick={() => handleCardClick(announcementData[announcementData.length - 2].id)}>
            <img
              src={announcementData[announcementData.length - 2].image}
              alt=""
              className="main-image"
            />
            <div className="content-text-annoument">
              <div className="box-head-annoutment">
                <div
                  className={
                    announcementData[announcementData.length - 2].type ===
                    "Activity"
                      ? "box-activety"
                      : announcementData[announcementData.length - 2].type ===
                        "News"
                      ? "box-new"
                      : "box-blog"
                  }
                >
                  {announcementData[announcementData.length - 2].type.toUpperCase()}
                </div>
                <div className="date">
                  <img src={calendar} alt="" className="calendar" />
                  <div className="text-date">
                    {announcementData[announcementData.length - 2].date}
                  </div>
                </div>
              </div>
              <div className="box-text-annoutment">
                <div className="box-text-head-annoutment">
                  {announcementData[announcementData.length - 2].name}
                </div>
                <div className="box-text-sub-annoutment">
                  {announcementData[announcementData.length - 2].description}
                </div>
              </div>
            </div>
          </div>
          <div className="mobile-card-annoument" onClick={() => handleCardClick(announcementData[announcementData.length - 3].id)}>
            <img
              src={announcementData[announcementData.length - 3].image}
              alt=""
              className="main-image"
            />
            <div className="content-text-annoument">
              <div className="box-head-annoutment">
                <div
                  className={
                    announcementData[announcementData.length - 3].type ===
                    "Activity"
                      ? "box-activety"
                      : announcementData[announcementData.length - 3].type ===
                        "News"
                      ? "box-new"
                      : "box-blog"
                  }
                >
                  {announcementData[announcementData.length - 3].type.toUpperCase()}
                </div>
                <div className="date">
                  <img src={calendar} alt="" className="calendar" />
                  <div className="text-date">
                    {announcementData[announcementData.length - 3].date}
                  </div>
                </div>
              </div>
              <div className="box-text-annoutment">
                <div className="box-text-head-annoutment">
                  {announcementData[announcementData.length - 3].name}
                </div>
                <div className="box-text-sub-annoutment">
                  {announcementData[announcementData.length - 3].description}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Annoument;
